<script setup>
import WhatsAppTemplateParser from 'dashboard/components-next/whatsapp/WhatsAppTemplateParser.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { useI18n } from 'vue-i18n';
import { useViewportMaxHeight } from 'dashboard/composables/zimobi/useViewportMaxHeight';

defineProps({
  template: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['sendMessage', 'back']);

const { t } = useI18n();
// Zimobi: keeps the parser inside the viewport when the compose form sits low.
const { panelRef, maxHeight } = useViewportMaxHeight();

const handleSendMessage = payload => {
  emit('sendMessage', payload);
};

const handleBack = () => {
  emit('back');
};
</script>

<template>
  <div
    ref="panelRef"
    :style="{ maxHeight: `${maxHeight}px` }"
    class="absolute top-full mt-1.5 overflow-y-auto left-0 right-0 ltr:md:right-auto rtl:md:left-auto flex flex-col gap-4 px-4 pt-6 pb-5 items-start w-auto md:w-[28.75rem] h-auto bg-n-solid-2 border border-n-strong shadow-sm rounded-lg"
  >
    <!-- Zimobi: full width on phones, viewport-capped height, conversation extras (file header, Liquid). -->
    <div class="w-full">
      <WhatsAppTemplateParser
        :template="template"
        for-conversation
        @send-message="handleSendMessage"
        @back="handleBack"
      >
        <template #actions="{ sendMessage, goBack, disabled }">
          <div class="flex gap-3 justify-between items-end w-full h-14">
            <Button
              :label="
                t(
                  'COMPOSE_NEW_CONVERSATION.FORM.WHATSAPP_OPTIONS.TEMPLATE_PARSER.BACK'
                )
              "
              color="slate"
              variant="faded"
              class="w-full font-medium"
              @click="goBack"
            />
            <Button
              :label="
                t(
                  'COMPOSE_NEW_CONVERSATION.FORM.WHATSAPP_OPTIONS.TEMPLATE_PARSER.SEND_MESSAGE'
                )
              "
              class="w-full font-medium"
              :disabled="disabled"
              @click="sendMessage"
            />
          </div>
        </template>
      </WhatsAppTemplateParser>
    </div>
  </div>
</template>
